/*!
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: GPL-3.0-or-later
 */
export var ShareType;
(function (ShareType) {
    ShareType[ShareType["User"] = 0] = "User";
    ShareType[ShareType["Group"] = 1] = "Group";
    ShareType[ShareType["Link"] = 3] = "Link";
    ShareType[ShareType["Email"] = 4] = "Email";
    ShareType[ShareType["Remote"] = 6] = "Remote";
    /**
     * Was called `Circle` before Nextcloud 29
     */
    ShareType[ShareType["Team"] = 7] = "Team";
    ShareType[ShareType["Guest"] = 8] = "Guest";
    ShareType[ShareType["RemoteGroup"] = 9] = "RemoteGroup";
    ShareType[ShareType["Room"] = 10] = "Room";
    ShareType[ShareType["Deck"] = 12] = "Deck";
    /**
     * @since 26.0.0
     */
    ShareType[ShareType["FederatedGroup"] = 14] = "FederatedGroup";
    /**
     * Third party share types
     *
     * @since 25.0.0
     */
    ShareType[ShareType["ScienceMesh"] = 15] = "ScienceMesh";
})(ShareType || (ShareType = {}));
